"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/internal_shipping_error.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalShippingNotFoundError = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.shipping.v1.InternalShippingNotFoundError
 */
class InternalShippingNotFoundError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string reason = 1;
         */
        this.reason = "";
        /**
         * @generated from field: string domain = 2;
         */
        this.domain = "";
        /**
         * @generated from field: map<string, string> metadata = 3;
         */
        this.metadata = {};
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalShippingNotFoundError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalShippingNotFoundError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalShippingNotFoundError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalShippingNotFoundError, a, b);
    }
}
exports.InternalShippingNotFoundError = InternalShippingNotFoundError;
InternalShippingNotFoundError.runtime = protobuf_1.proto3;
InternalShippingNotFoundError.typeName = "spwn.shipping.v1.InternalShippingNotFoundError";
InternalShippingNotFoundError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
//# sourceMappingURL=internal_shipping_error_pb.js.map